import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function injectCriticalHints() {
  const head = document.head;
  // Preconnect to critical origins
  const origins = [{
    href: 'https://cdn.shopify.com',
    crossOrigin: false
  }, {
    href: 'https://fonts.googleapis.com',
    crossOrigin: false
  }, {
    href: 'https://fonts.gstatic.com',
    crossOrigin: true
  }, {
    href: 'https://fast.wistia.com',
    crossOrigin: false
  }];
  origins.forEach(({
    href,
    crossOrigin
  }) => {
    if (document.querySelector(`link[href="${href}"]`)) return;
    // dns-prefetch as fallback
    const dns = document.createElement('link');
    dns.rel = 'dns-prefetch';
    dns.href = href;
    head.appendChild(dns);
    // preconnect
    const pc = document.createElement('link');
    pc.rel = 'preconnect';
    pc.href = href;
    if (crossOrigin) pc.crossOrigin = 'anonymous';
    head.appendChild(pc);
  });
  // Preload hero LCP image with full srcset
  const heroBase = 'https://cdn.shopify.com/s/files/1/1045/1160/3027/files/imagen_2026-02-16_132718062_1.webp?v=1771244858';
  const preload = document.createElement('link');
  preload.rel = 'preload';
  preload.as = 'image';
  preload.href = `${heroBase}&width=800`;
  preload.setAttribute('imagesrcset', [360, 480, 640, 800, 1000, 1200].map(w => `${heroBase}&width=${w} ${w}w`).join(', '));
  preload.setAttribute('imagesizes', '(max-width: 640px) 100vw, (max-width: 1024px) 60vw, 800px');
  preload.setAttribute('fetchpriority', 'high');
  head.appendChild(preload);
})();
render(<App data-id="element-246" />, document.getElementById('root'));